// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2zaj9","legacyBtn":"MutateMid_legacyBtn__3bxxF"};